<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start stretch" >
	<div fxFlex="5%">
		   <sui-checkbox >
            </sui-checkbox>
	</div>
		<div fxFlex="25%">{{role?.roleName}}</div>
		<div fxFlex>{{role?.roleDescription}}</div>
		<div fxFlex  class="text-right">
			<button class="ui circular tiny button" *isPermitted="{id:'ADMIN_ROLE',action:'remove'}" (click)="onDelete.emit(role)"><i class="trash icon"></i></button>
			<a class="ui circular tiny button" *isPermitted="{id:'ADMIN_ROLE',action:'view'}" routerLink="/admin/setting/role/detail/{{role.roleId}}"><i class="eye icon"></i></a>
		</div>
</div>